"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSiteCirrusStore = void 0;
const react_cirrus_store_1 = require("@yanzi/react-cirrus-store");
const useSiteCirrusStorePath_1 = require("./useSiteCirrusStorePath");
function useSiteCirrusStore(path) {
    const storePath = useSiteCirrusStorePath_1.useSiteCirrusStorePath();
    return react_cirrus_store_1.useCirrusStore(`${storePath}/${path.replace(/^\//, '')}`);
}
exports.useSiteCirrusStore = useSiteCirrusStore;
//# sourceMappingURL=useSiteCirrusStore.js.map